import React from 'react'
import PropTypes from 'prop-types'

import FlatButton from 'material-ui/FlatButton/FlatButton'
import Popover from 'material-ui/Popover'
import Menu from 'material-ui/Menu'
import MenuItem from 'material-ui/MenuItem'

const SAVE_AND_SEND = 'SS'
const SAVE_AS_DRAFT = 'DF'
const DELETE = 'D'

const EstimateOptions = ({ open, isNewEstimate, estimateStatus, anchorElement, onCloseRequested,
  onSaveAndSendSelected, onSaveAsDraftSelected, onDeleteSelected }) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorElement}
      anchorOrigin={{horizontal: 'middle', vertical: 'bottom'}}
      targetOrigin={{horizontal: 'left', vertical: 'bottom'}}
      onRequestClose={onCloseRequested}>
      <Menu>
        <MenuItem
          key={SAVE_AND_SEND}
          onTouchTap={onSaveAndSendSelected}
          primaryText={isNewEstimate || estimateStatus === 'draft' ? 'Save & Send' : 'Resend'} />
        <MenuItem
          key={SAVE_AS_DRAFT}
          onTouchTap={onSaveAsDraftSelected}
          primaryText={isNewEstimate || estimateStatus === 'draft' ? 'Save as Draft' : 'Save'} />
        { !isNewEstimate &&
          <MenuItem
            key={DELETE}
            onTouchTap={onDeleteSelected}
            primaryText={'Delete'} />
        }
      </Menu>
    </Popover>
  )
}

EstimateOptions.propTypes = {
  open: PropTypes.bool.isRequired,
  isNewEstimate: PropTypes.bool.isRequired,
  estimateStatus: PropTypes.string,
  anchorElement: PropTypes.object,
  onCloseRequested: PropTypes.func.isRequired,
  onSaveAndSendSelected: PropTypes.func.isRequired,
  onSaveAsDraftSelected: PropTypes.func.isRequired,
  onDeleteSelected: PropTypes.func.isRequired
}

export default class EstimateFooter extends React.Component {

  static propTypes = {
    mode: PropTypes.string.isRequired,
    isNewEstimate: PropTypes.bool.isRequired,
    estimateStatus: PropTypes.string,
    onSwitchModeClicked: PropTypes.func.isRequired,
    onSaveAndSendClicked: PropTypes.func.isRequired,
    onSaveAsDraftClicked: PropTypes.func.isRequired,
    onDeleteClicked: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)
    this.state = {
      openSaveOptions: false
    }
  }

  handleSaveActions = event => {
    event.preventDefault()
    this.setState({
      anchorElement: event.currentTarget,
      openSaveOptions: true
    })
  }

  handleSwitchModeClicked = event => {
    event.preventDefault()
    this.props.onSwitchModeClicked()
  }

  handleSaveAndSendClicked = event => {
    event.preventDefault()
    this.setState({
      openSaveOptions: false
    })
    this.props.onSaveAndSendClicked()
  }

  handleSaveAsDraftClicked = event => {
    event.preventDefault()
    this.setState({
      openSaveOptions: false
    })
    this.props.onSaveAsDraftClicked()
  }

  handleDeleteClicked = event => {
    event.preventDefault()
    this.setState({
      openSaveOptions: false
    })
    this.props.onDeleteClicked()
  }

  handleCloseRequested = () => {
    this.setState({
      openSaveOptions: false
    })
  }

  render() {
    return (
      <div style={styles.footer}>
        <FlatButton
          style={{border: '1px solid #e2e2e2'}}
          label={this.props.mode === 'preview' ? 'Estimate' : 'Preview'}
          backgroundColor='#fff'
          onTouchTap={this.handleSwitchModeClicked}/>
        <div style={styles.separator} />
        <FlatButton
          style={{ border: '1px solid #4d6f7f', marginRight: 16 }}
          labelStyle={{ color: '#4d6f7f' }}
          label='Actions'
          backgroundColor='#fff'
          onTouchTap={this.handleSaveActions}/>
        <EstimateOptions
          open={this.state.openSaveOptions}
          isNewEstimate={this.props.isNewEstimate}
          estimateStatus={this.props.estimateStatus}
          anchorElement={this.state.anchorElement}
          onCloseRequested={this.handleCloseRequested}
          onSaveAndSendSelected={this.handleSaveAndSendClicked}
          onSaveAsDraftSelected={this.handleSaveAsDraftClicked}
          onDeleteSelected={this.handleDeleteClicked}/>
      </div>
    )
  }

}

const styles = {
  footer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 60,
    backgroundColor: '#fafafa'
  },
  separator: {
    width: 16
  }
}



// WEBPACK FOOTER //
// ./src/billing/estimates/EstimateFooter.js